import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    stepType: '',
    stepName: '',
    stepIndex: 0,
    menuDatas: null,   
    menuIndex: 0, 
    currentStates: [],
    path: ''
};

const tutorialSlice = createSlice({
    name: 'tutorial',
    initialState,
    reducers: {
        setCurrent: (state, action) => {
            state.stepIndex = action.payload.stepIndex;
            state.stepName = action.payload.stepName;
            state.stepType = action.payload.stepType;
            state.menuIndex = action.payload.menuIndex;
            state.path = action.payload.path;
        },
        //메뉴 데이터 세팅
        setMenu: (state, action) => {
            state.menuDatas = action.payload.menuDatas;
        },
        //목차별 진행상태(배열)
        setCurrentState: (state, action) => {
            state.currentStates = action.payload.currentStates;
        },
        //현재 목차의 스텝
        setCurrentStep: (state, action) => {
            state.stepIndex = action.payload.stepIndex;
            state.stepName = action.payload.stepName;
            state.stepType = action.payload.stepType;
        },
        //현재 목차
        setCurrentMenu: (state, action) => {
            state.menuIndex = action.payload.menuIndex;
        },
        setTutorialInfo: (state, action) => {
            const updates = action.payload;
            Object.keys(updates).forEach(key => {
                state[key] = updates[key];
            });
        },
        //경로 설정
        setPath: (state, action) => {
            const path = action.payload;        
            const menuIndex = parseInt(path.split('/')[0]);
            const stepIndex = parseInt(path.split('/')[1]);
            state.path = action.payload;
            state.menuIndex = menuIndex;
            state.stepIndex = stepIndex;
            
        },
        setInit: () => initialState,
        setAll: (state, action) => {
            state.currentStates = action.payload.currentStates;
            state.menuDatas = action.payload.menuDatas;
            state.menuIndex = action.payload.menuIndex;
            state.stepIndex = action.payload.stepIndex;
            state.stepName = action.payload.stepName;
            state.stepType = action.payload.stepType;
        },
        setComplete: (state, action) => {
            const index = action.payload.menuIndex;
            const isComplete = action.payload.complete;
            const datas = state.menuDatas;
            if(datas.children[index]) {
                datas.children[index] = {
                    ...datas.children[index],
                    complete: isComplete
                };
            }
            state.menuDatas = datas;
        }
    }
});

export const { setMenu, setCurrentState, setCurrentStep, setCurrentMenu, setTutorialInfo, setPath, setInit, setAll, setCurrent, setComplete } = tutorialSlice.actions;
export default tutorialSlice.reducer;